import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ApiDataService } from "../services/api.service";
import { ShService } from "../services/sh-service";

@Injectable({
    providedIn: 'root',
})
export class storageService {
    constructor(
        private router: Router,
        private _apiService: ApiDataService,
        private _service: ShService,
    ){}

    public setStorage(x: any){
        this.getLabels();
        sessionStorage.setItem('email', x.email);
        x.role ? sessionStorage.setItem('role', x.userType) : null;
        sessionStorage.setItem('name', x.name);
        sessionStorage.setItem('token', x.token);
        sessionStorage.setItem('refresh-token', x.refreshToken);
        sessionStorage.setItem('profileImg', x.profilePic);
        sessionStorage.setItem("timeout", x.sessionTimeOut);
        sessionStorage.setItem("allowedOrgs", JSON.stringify(x.threePlList));
        sessionStorage.setItem("lobcolor", JSON.stringify(x.lobColorMap));
        sessionStorage.setItem('userName', x.userName);
        (x.userType === 0 || x.userType === 1 || x.userType === 99)? (sessionStorage.setItem('org', ''), sessionStorage.setItem('currentProfile', '0')) : sessionStorage.setItem('currentProfile', '1');
        
        this.router.navigate(["/dashboard"]);
    }

    private getLabels() {
        this._apiService.getLabels().subscribe(x => {
            sessionStorage.setItem('labels', JSON.stringify(x[0]));
            this._service.isLoggedIn$.next(true);
            this._service.isLabelLoaded$.next(true);
        });
    }
}